import { boundApiRequest } from '@/restapi/restapi.base.js';

const doRequest = boundApiRequest('/api/document/');


export async function save(file) {
    const reqt = new FormData();
    reqt.set('name', file.name);
    reqt.set('data', file, file.name);

    const { result } = await doRequest('save', reqt, { messages: false });
    return result;
}

export async function updateInfo(resp) {
    const { result } = await doRequest('update', resp, { blocking: true });
    return result;
}

export async function updateInfoList(resp) {
    const { result } = await doRequest('update/list', resp);
    return result;
}
